import React from "react";
import clsx from "clsx";
import _ from "lodash";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

import BaseDialog from "../../../../components/BaseDialog/BaseDialog";
import PrimaryButton from "../../../../components/Buttons/PrimaryButton";
import {MissingRequiredIcon} from "../../../../components/Icons/WarningIcon";
import SkipIcon from "../../../../components/Icons/SkipIcon";

import useStyles from "./styles";

const MissingFieldsSummary = (props) => {
  const {
    missingFieldsData,
    navigateToPrevMenu,
    handleClose,
  } = props;

  const [hasRequired, hasToConfirm] = React.useMemo(() => {
    if (!missingFieldsData || !missingFieldsData.length) return [false, false];

    let hasRequired = false;
    let hasToConfirm = false;

    for (let i = 0; i < missingFieldsData.length; i++) {
      const steps = missingFieldsData[i].steps;
      for (let j = 0; j < steps.length; j++) {
        const questions = steps[j].questions;
        for (let k = 0; k < questions.length; k++) {
          if (questions[k].toConfirm) {
            hasToConfirm = true;
          } else {
            hasRequired = true;
          }
          if (hasRequired && hasToConfirm) return [true, true];
        }
      }
    }

    return [hasRequired, hasToConfirm];
  }, [missingFieldsData]);
  const classes = useStyles({hasRequired});

  const missingDataList = missingFieldsData || [];

  return (
    <BaseDialog
      title={'Angaben prüfen und vervollständigen'}
      open={!!missingFieldsData}
      handleClose={handleClose}
      maxWidth={'md'}
      customClasses={classes}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} className={classes.infoMsg}>
          Bitte prüfen und vervollständigen Sie die unten aufgeführten Angaben.
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            {hasRequired && (
              <Grid item>
                <Grid container spacing={1} alignItems={'center'} wrap={"nowrap"}>
                  <Grid item><StylesMissingRequiredIcon /></Grid>
                  <Grid item>Fehlende Pflichtangaben ergänzen</Grid>
                </Grid>
              </Grid>
            )}
            {hasToConfirm && (
              <Grid item>
                <Grid container spacing={1} alignItems={'center'} wrap={"nowrap"}>
                  <Grid item><StylesSkipIcon /></Grid>
                  <Grid item>Vorausgefüllte Angaben prüfen und bestätigen</Grid>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
        {missingDataList.map((menu, idx) => (
          <>
            <Grid key={idx} item xs={12} className={classes.menuContainer}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Grid container justify={'space-between'} alignItems={"center"}>
                    <Grid item className={classes.menuName}>{menu.name}</Grid>
                    <Grid item>
                      <PrimaryButton
                        onButtonClick={() => navigateToPrevMenu(menu.uid)}
                        text={'Anzeigen'}
                        icon={<i className={'fa fa-long-arrow-right'} />}
                        iconPosition={'right'}
                        variant={'text'}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {menu.steps.map(step => (
                  <Grid key={step.uid} item xs={12} className={classes.stepContainer}>
                    <Grid container justify={'space-between'} alignItems={"center"}>
                      <Grid item className={classes.stepName}>
                        {!!step.parent && (
                          <>{step.parent}<i className={clsx('fal fa-angle-right', classes.arrowBreadcrumb)} /></>
                        )}
                        {step.name}
                      </Grid>
                      <Grid item>
                        <PrimaryButton
                          onButtonClick={() => navigateToPrevMenu(menu.uid, step.uid)}
                          text={'Anzeigen'}
                          icon={<i className={'fa fa-long-arrow-right'} />}
                          iconPosition={'right'}
                          variant={'text'}
                        />
                      </Grid>
                    </Grid>
                    <MissingSummaryForStep classes={classes} step={step} />
                  </Grid>
                ))}
              </Grid>
            </Grid>
            {idx !== (missingDataList.length - 1) && (
              <Grid item xs={12}><Divider /></Grid>
            )}
          </>
        ))}
        <Grid item xs={12} />
      </Grid>
    </BaseDialog>
  )
};

export default MissingFieldsSummary;

const getQuestionName = (step, q) => q.name || q.question_text || step.stepName || '';

const MissingSummaryForStep = ({step, classes}) => {
  const questions = React.useMemo(() => {
    return _.uniqBy(step.questions, q => getQuestionName(step, q))
  }, [step.questions])

  return !!questions.length && (
    <Grid container>
      {questions.map((q, idx) => (
        <Grid key={idx} item xs={12} className={classes.missingField}>
          <Grid container spacing={1} alignItems={'center'} wrap={"nowrap"}>
            <Grid item>{q.toConfirm ? <StylesSkipIcon /> : <StylesMissingRequiredIcon />}</Grid>
            <Grid item className={!q.toConfirm && 'red'}>{getQuestionName(step, q)}</Grid>
          </Grid>
        </Grid>
      ))}
    </Grid>
  )
}

const IconWrapper = ({children}) => (
  <span style={{fontSize: 20}}>{children}</span>
)

const StylesSkipIcon = () => <IconWrapper><SkipIcon /></IconWrapper>
const StylesMissingRequiredIcon = () => <IconWrapper><MissingRequiredIcon /></IconWrapper>